import { defineComponent, h } from "vue";
import { props } from "./../shared/index.js";
export default defineComponent({
  name: "RenderCacheable",
  props,
  setup(props2, { slots }) {
    return () => {
      const tag = props2.tag ?? "div";
      if (!slots.default) {
        return () => h(tag, {
          innerHTML: ""
        });
      }
      const defaultSlot = slots.default();
      return h(tag, defaultSlot);
    };
  }
});
